var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.className},[(_vm.isUndefined)?_c('span',{staticClass:"text-muted"},[_vm._v("–")]):[(_vm.isPositive)?[_vm._v("+")]:_vm._e(),_c('number',{attrs:{"number":_vm.change,"options":{minimumFractionDigits: 0, maximumFractionDigits: 0}}}),_vm._v("%\n  ")]],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8533cb92","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/number-change.vue
// module id = null
// module chunks = 